import { createFileRoute } from "@tanstack/react-router"
import { useEffect } from "react"
import { useAppNavigate } from "#/hooks/use-app-navigate"
import { useStonelog } from "#/lib/stonelog-context"

export const Route = createFileRoute("/_authenticated/stonelog/")({
	component: StonelogIndex,
})

function StonelogIndex() {
	const { currentLogId } = useStonelog()
	const navigate = useAppNavigate()

	useEffect(() => {
		if (currentLogId) {
			navigate({ to: "/stonelog/dashboard" })
		} else {
			navigate({ to: "/stonelog/select-log" })
		}
	}, [currentLogId, navigate])

	return null
}
